// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ChevronSmallLeftDoubleIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="ChevronSmallLeftDoubleIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M13.765 5.75 9.52 10l4.246 4.25 1.062-1.062L11.642 10l3.185-3.187z" />
      <path d="M8.623 5.75 4.377 10l4.246 4.25 1.062-1.062L6.5 10l3.185-3.187z" />
    </SvgIcon>
  );
});

/**
 * Use to collapse the sidebar
 * @public
 */
export const ChevronSmallLeftDoubleIcon = /* @__PURE__ */ Object.assign(
  ChevronSmallLeftDoubleIconComponent,
  { displayName: 'ChevronSmallLeftDoubleIcon' },
);
